import { useCallback } from 'react';

import { useNavigate } from '@xing-com/crate-core-router';
import { useEntityPageStore } from '@xing-com/crate-entity-pages-entity-pages-shared-context-entity-page-context';

import { useEditStore } from '../../store/edit-store';

export const useToggleEditMode = (): {
  toggleEditMode: (isEditing: boolean) => void;
} => {
  const navigate = useNavigate();

  const setIsEditing = useEditStore(({ setIsEditing }) => setIsEditing);
  const isEditor = useEntityPageStore(
    ({ pageContext }) => pageContext.isEditor
  );

  return {
    toggleEditMode: useCallback(
      (value: boolean) => {
        if (!isEditor) return;

        const url = new URL(window.location.href);
        const params = url.searchParams;
        if (params.has('edit')) {
          params.delete('edit');
        } else {
          params.set('edit', 'true');
        }
        navigate(`${url.pathname}?${params.toString()}`, { replace: true });
        setIsEditing(value);
      },
      [isEditor, navigate, setIsEditing]
    ),
  };
};
